
import * as angular from "angular";

import "./resourceManagement.scss";

export class ResourceManagementController implements angular.IComponentController {
    
    static $inject = [];

    constructor() {
    }

    $onInit() {
    }
}
